import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Layout from "./Layout";
import React, { Suspense } from "react";
import Home from "../pages/home/Home";
import BlogListing from "../pages/Bloglisting/BlogListing";
import AiDetails from "../pages/aiBlogDetail.js/AiDetails";
import IntegtrationListing from "../pages/Integration/IntegrationListing/IntegtrationListing";
import IntegrationDetails from "../pages/Integration/IntegrationDetails/IntegrationDetails";
import { useModal } from "../contexts/ModalContext";
import MediaListing from "../pages/media/mediaListing/MediaListing";
import MediaDetail from "../pages/media/mediaDetail/MediaDetail";
import ComparisonListing from "../pages/Comparison/ComparisonListing/ComparisonListing";
import ComparisonDetaling from "../pages/Comparison/ComparisonDetaling/ComparisonDetaling";

function routeComponent(loader, serverPath) {
  // eslint-disable-next-line no-eval
  const serverComponent = typeof window === "undefined" ? eval("require")(serverPath).default : null;
  const Component = typeof window === "undefined"
    // Keep SSR synchronous while allowing webpack to split browser routes.
    ? serverComponent
    : React.lazy(loader);

  return function RouteComponent(props) {
    return (
      <Suspense fallback={null}>
        <Component {...props} />
      </Suspense>
    );
  };
}

const ErrorPage = routeComponent(() => import("../pages/errorPage/ErrorPage"), "../pages/errorPage/ErrorPage");
const ThankYou = routeComponent(() => import("../pages/thankYou/ThankYou"), "../pages/thankYou/ThankYou");
const ContactUs = routeComponent(() => import("../pages/contactUs/ContactUs"), "../pages/contactUs/ContactUs");
const AboutUs = routeComponent(() => import("../pages/aboutUs/AboutUs"), "../pages/aboutUs/AboutUs");
const TmsPage = routeComponent(() => import("../pages/LogisticsServices/tmsPage/TmsPage"), "../pages/LogisticsServices/tmsPage/TmsPage");
const WmsPage = routeComponent(() => import("../pages/LogisticsServices/wmsPage/WmsPage"), "../pages/LogisticsServices/wmsPage/WmsPage");
const FirstMile = routeComponent(() => import("../pages/LogisticsServices/firstMile/FirstMile"), "../pages/LogisticsServices/firstMile/FirstMile");
const MidMile = routeComponent(() => import("../pages/LogisticsServices/midMile/MidMile"), "../pages/LogisticsServices/midMile/MidMile");
const LastMile = routeComponent(() => import("../pages/LogisticsServices/lastMile/LastMile"), "../pages/LogisticsServices/lastMile/LastMile");
const ShipmentTracking = routeComponent(() => import("../pages/LogisticsServices/shipmentTracking/ShipmentTracking"), "../pages/LogisticsServices/shipmentTracking/ShipmentTracking");
const RouteOptimization = routeComponent(() => import("../pages/LogisticsServices/routePage/RouteOptimization"), "../pages/LogisticsServices/routePage/RouteOptimization");
const GroceriesQuickCommerce = routeComponent(() => import("../pages/Industries/GroceriesQuickCommerce/GroceriesQuickCommerce"), "../pages/Industries/GroceriesQuickCommerce/GroceriesQuickCommerce");
const AutoMotiveIndustry = routeComponent(() => import("../pages/Industries/AutoMotiveIndustry/AutoMotiveIndustry"), "../pages/Industries/AutoMotiveIndustry/AutoMotiveIndustry");
const ConsumerGoods = routeComponent(() => import("../pages/Industries/ConsumerGoods/ConsumerGoods"), "../pages/Industries/ConsumerGoods/ConsumerGoods");
const ProcessManufacturing = routeComponent(() => import("../pages/Industries/ProcessManufacturing/ProcessManufacturing"), "../pages/Industries/ProcessManufacturing/ProcessManufacturing");
const PostParcelCarriers = routeComponent(() => import("../pages/Industries/PostParcelCarriers/PostParcelCarriers"), "../pages/Industries/PostParcelCarriers/PostParcelCarriers");
const FreightForwarders = routeComponent(() => import("../pages/Industries/FreightForwarders/FreightForwarders"), "../pages/Industries/FreightForwarders/FreightForwarders");
const RetailQuickCommerce = routeComponent(() => import("../pages/Industries/RetailQuickCommerce/RetailQuickCommerce"), "../pages/Industries/RetailQuickCommerce/RetailQuickCommerce");
const PrivacyPolicy = routeComponent(() => import("../pages/privacy/PrivacyPolicy"), "../pages/privacy/PrivacyPolicy");
const Calculator = routeComponent(() => import("../pages/calculator/Calculator"), "../pages/calculator/Calculator");
const LogisticsIndustries = routeComponent(() => import("../pages/logisticsIndustries/LogisticsIndustries"), "../pages/logisticsIndustries/LogisticsIndustries");
const Pricing = routeComponent(() => import("../pages/pricing/Pricing"), "../pages/pricing/Pricing");
const FeatureDetails = routeComponent(() => import("../pages/FeatureDetails/FeatureDetails"), "../pages/FeatureDetails/FeatureDetails");
const FeatureListing = routeComponent(() => import("../pages/FeatureListing/FeatureListing"), "../pages/FeatureListing/FeatureListing");
const CaseStudy = routeComponent(() => import("../pages/caseStudy/CaseStudy"), "../pages/caseStudy/CaseStudy");
const DynamicPage = routeComponent(() => import("../pages/DynamicPage/DynamicPage"), "../pages/DynamicPage/DynamicPage");
const CaseStudyDetail = routeComponent(() => import("../pages/caseStudyDetail/CaseStudyDetail"), "../pages/caseStudyDetail/CaseStudyDetail");
const DemoForm = routeComponent(() => import("../pages/DemoForm/DemoForm"), "../pages/DemoForm/DemoForm");
const InquiryModal = React.lazy(() => import("../components/InquiryModal"));

function Redirect({ to }) {
  if (typeof window !== "undefined") {
    return <Navigate to={to} replace />;
  }
  return null;
}

export default function NavRouter({ initialData }) {
    const { modalShow, closeQueryModal } = useModal();
  return (
    <>
      <ScrollToTop />
       {modalShow && (
         <Suspense fallback={null}>
           <InquiryModal show={modalShow} setShow={closeQueryModal} />
         </Suspense>
       )}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home initialData={initialData} />} />
          <Route  path="blogs"   element={<BlogListing initialData={initialData} />} />
          <Route  path="blogs/:slug"  element={<AiDetails initialData={initialData} />}  />
          {/* <Route path="blog-details" element={<BlogDetails />} />*/}
          {/* <Route path="ai-blog-details" element={<AiDetails />} />  */}
          <Route path="404" element={<ErrorPage />} />
          <Route path="thank-you" element={<ThankYou />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="about-us"  element={<AboutUs initialData={initialData} />}  />
          <Route path="transportation-management-services-tms"  element={<TmsPage />} />
          <Route path="warehouse-management-system-wms" element={<WmsPage />} />
          <Route path="first-mile-logistics" element={<FirstMile />} />
          <Route path="middle-mile-logistics" element={<MidMile />} />
          <Route path="last-mile-delivery-logistics" element={<LastMile />} />
          <Route path="shipment-tracking" element={<ShipmentTracking />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="calculator" element={<Calculator  initialData={initialData}/>} />
          <Route path="route-optimization-features" element={<FeatureListing  initialData={initialData}/>} />
          <Route path="route-optimization-features/:feature_slug" element={<FeatureDetails  initialData={initialData}/>} />
           <Route path="pricing" element={<Pricing  initialData={initialData}/>} />
          <Route path="/:category/:slug" element={<LogisticsIndustries  initialData={initialData}/>} />

          <Route path="media" element={<MediaListing initialData={initialData}/>} />
          <Route path="media/:slug" element={<MediaDetail initialData={initialData}/>} />
          <Route path="comparison" element={<ComparisonListing initialData={initialData}/>} />
          <Route path="comparison/:slug" element={<ComparisonDetaling initialData={initialData}/>} />

          {/* Industries Page */}
          <Route  path="grocery-delivery-management-software"   element={<GroceriesQuickCommerce />}  />
          <Route  path="automotive-supply-chain-platform"  element={<AutoMotiveIndustry />} />
          <Route  path="consumer-goods-logistics-platform"  element={<ConsumerGoods />} />
          <Route  path="process-manufacturing-logistics-solutions"  element={<ProcessManufacturing />} />
          <Route  path="post-parcel-carriers-software"  element={<PostParcelCarriers />}  />
          <Route  path="freight-management-solutions"  element={<FreightForwarders />} />
          <Route  path="retail-quick-commerce-solutions"    element={<RetailQuickCommerce />}  />
          <Route  path="route-optimization-and-planning"    element={<RouteOptimization initialData={initialData}/>} />
          {/* <Route  path="testing-form"    element={<DemoForm/>} /> */}
          

          {/* case study */}
          <Route  path="case-study"   element={<CaseStudy initialData={initialData}/>}  /> 
          <Route  path="case-study/:case_slug"   element={<CaseStudyDetail initialData={initialData}/>}  /> 

          {/* integration */}
            <Route  path="integration"   element={<IntegtrationListing initialData={initialData}/>}  /> 
            <Route  path="integration/:slug"   element={<IntegrationDetails initialData={initialData}/>}  />
            <Route path="/:dynamic_slug" element={<DynamicPage initialData={initialData}/>}  /> 
          <Route  path="*" element={<Redirect to="/404" />} />
        </Route>
      </Routes>
    </>
  );
}
